const styles = theme => ({
    fullWidth: {
        width: '100%',
    },
    container: {
        width: '100%',
        marginBottom: theme.spacing(2),
        marginTop: theme.spacing(4),
    },
    body: {
        marginBottom: theme.spacing(2),
    }
});

export default styles;